import React, { useState } from "react";
import clsx from "clsx";
import { NavLink, Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { useAuth } from "contexts/auth-context";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: "#E21833",
		height: 72,
	},
	bar: {
		backgroundColor: "rgba(249,248,250, 0.8)",
		color: theme.palette.getContrastText("rgba(249,248,250, 0.8)"),
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	navButton: {
		marginRight: theme.spacing(1),
	},
	title: {
		flexGrow: 1,
	},
	spacer: {
		flexGrow: 1,
	},
	list: {
		width: 250,
	},
	activeLink: {
		fontWeight: "bold",
		// color: "red",
		"&:hover": {
			color: theme.palette.common.white,
		},
	},
}));
const pages = [
	{ id: "home", text: "Home", to: "/" },
	{ id: "covid", text: "COVID-19", to: "/covid-19" },
	{ id: "apps", text: "Software", to: "/software" },
	{ id: "education", text: "Education", to: "/education" },
	{ id: "news", text: "News", to: "/news" },
	{ id: "jobs", text: "Jobs!", to: "/jobs" },
	{ id: "about", text: "About", to: "/about" },
];
export default function NavBar() {
	const classes = useStyles();
	const { user, login, logout } = useAuth();
	const theme = useTheme();
	const isBig = useMediaQuery(theme.breakpoints.up("md"));
	const [open, setOpen] = useState(false);
	const toggleDrawer = (open) => (event) => {
		setOpen(open);
	};
	return (
		<div className={classes.root}>
			<AppBar position="static" elevation={0} className={classes.bar}>
				<Toolbar>
					{!isBig && (
						<IconButton
							edge="start"
							className={classes.menuButton}
							color="inherit"
							aria-label="menu"
							onClick={toggleDrawer(true)}
						>
							<MenuIcon />
						</IconButton>
					)}
					<Link
						to="/"
						style={{
							display: "inline-flex",
							flexDirection: "row",
							justifyContent: "center",
							alignItems: "center",
							color: "inherit",
							textDecoration: "none",
							marginRight: 8,
						}}
					>
						<img
							className={clsx("img-brand", "img-header")}
							src={`${process.env.PUBLIC_URL}/logo_192.png`}
							alt=""
						/>{" "}
						<Typography variant="h6">City@UMD</Typography>
					</Link>
					{isBig &&
						pages.map((page) => (
							<Button
								component={NavLink}
								exact={page.to === "/"}
								to={page.to}
								key={page.id}
								// activeStyle={classes.activeLink}
								activeClassName={clsx(
									classes.activeLink,
									"MuiButton-contained",
									"MuiButton-containedPrimary"
								)}
								disableElevation
								className={classes.navButton}
							>
								{" "}
								{page.text}
							</Button>
						))}
					<span className={classes.spacer}></span>

					<a href="https://enme.umd.edu/">
						<img
							className="img-brand"
							src={`${process.env.PUBLIC_URL}/umd_logo.png`}
							alt=""
						/>
					</a>
				</Toolbar>
			</AppBar>
			<Drawer anchor={"left"} open={open} onClose={toggleDrawer(false)}>
				<div
					className={clsx(classes.list)}
					role="presentation"
					onClick={toggleDrawer(false)}
				>
					<List>
						{pages.map((page, index) => (
							<ListItem button key={page.id} component={Link} to={page.to}>
								<ListItemText primary={page.text} />
							</ListItem>
						))}
					</List>
					<Divider />
					<List>
						{user && (
							<ListItem button onClick={logout}>
								<ListItemText primary={"Logout"} />
							</ListItem>
						)}
						{!user && (
							<ListItem button component={Link} to="/user/login">
								<ListItemText primary={"Login"} />
							</ListItem>
						)}
					</List>
				</div>
			</Drawer>
		</div>
	);
}
